import React from "react";

const UserContext = React.createContext();

class UserProvider extends React.Component {
  constructor(props) {
    super(props);

    // 🔁 Load user from sessionStorage on init
    const storedUser = sessionStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;

    this.setUser = this.setUser.bind(this);
    this.logout = this.logout.bind(this);

    this.state = {
      user: user,
      isLoggedIn: !!user,
      setUser: this.setUser,
      logout: this.logout,
    };
  }

  setUser(user) {
    if (user) {
      sessionStorage.setItem("user", JSON.stringify(user));
    } else {
      sessionStorage.removeItem("user");
    }

    this.setState({
      user: user,
      access_token: user?.access_token || null,
      isLoggedIn: !!user,
    });
  }

  logout() {
    sessionStorage.removeItem("user");
    this.setState({ user: null, isLoggedIn: false });
  }

  render() {
    return (
      <UserContext.Provider value={this.state}>
        {this.props.children}
      </UserContext.Provider>
    );
  }
}

export { UserContext, UserProvider };
